/* IONIK (rendimiento): antes este código reiniciaba las animaciones de los textos gigantes en CADA
   movimiento del scroll. Ahora solo cambia la dirección cuando de verdad cambia, una vez por cuadro. */
(function () {
  const changeDirectionTicker = (className = "") => {
    const marqueeContents = document.querySelectorAll(className);
    if (!marqueeContents.length) return;
    let lastScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;
    let currentName = "slide";
    let ticking = false;

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          if (Math.abs(scrollTop - lastScrollTop) > 4) {
            const name = scrollTop > lastScrollTop ? "slide" : "slideReverse";
            if (name !== currentName) {
              currentName = name;
              marqueeContents.forEach((element) => {
                element.style.animationName = name;
              });
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
          }
          ticking = false;
        });
      },
      { passive: true }
    );
  };

  changeDirectionTicker(".promo-banner .marquee-tag.marquee-animate");
  changeDirectionTicker(".image-banner .marquee-tag.marquee-animate");
})();
